import React from 'react'
import { DialogContent, Grid, Typography } from '@mui/material'
import { TotallyMoneyLogo, InterstitialZutoLogo } from '@zuto/icons'
import CheckedList from '../../CheckedList'
import AnimatedArrows from '../../Animations/AnimatedArrows'
import { muiColors } from '@zuto/theme/src/mui/DefaultTheme'

const list = [
  'See if you can save money by refinancing',
  'Zuto are rated excellent on Trustpilot',
  'Get a finance decision in 60 seconds'
]

const TotallyMoneyInterstitialContent = (): JSX.Element => {
  return (
    <DialogContent sx={{ py: 12 }}>
      <Typography variant="rowHeading" color={muiColors.primary.blackAlt} mb={7} fontSize={14}>Transferring you to Zuto, our car finance partner</Typography>
      <Grid className="interstitial-header" container spacing={1} columns={3} alignItems="center" justifyContent="space-between" mb={7}>
        <Grid><TotallyMoneyLogo data-testid="totallymoney-logo" /></Grid>
        <Grid><AnimatedArrows data-testid="animated-arrows" /></Grid>
        <Grid><InterstitialZutoLogo data-testid="zuto-logo" /></Grid>
      </Grid>
      <CheckedList list={list} darkerText />
    </DialogContent>
  )
}

export default TotallyMoneyInterstitialContent
